export const CARD_TYPES = {
  GENERAL_INFO: "General Information",
  PUBLICATIONS: "publications",
  COMMUNITY_CONTRIBUTIONS: "communityContributions",
  REGION_BROWSER: "regionBrowser",
  STRUCTURAL_VARIANTS: "structuralVariants",
  BEACON_NETWORK: "beaconNetwork",
  EXPRESSION_DATA: "expressionData",
  DRUG_DATABASES: "drugDatabases",
  AMP: "amp",
  ACMG: "acmg",
  CONSERVATION_SCORES: "Conservation Scores",
  PATHOGENICITY_SCORES: "In-Silico Predictors",
  GWAS: "GWAS",
  TRANSCRIPTS: "Transcripts",
  CANCER_SAMPLES: "Cancer Samples",
  CLINVAR: "clinVar",
  SHOW_ALL: "Show All",
  CANCER_CURATED: "Cancer Curated",
  FREQUENCIES: "Frequencies",
  UNIPROT: "UniProt",
  GENE: "Gene",
};

export const CARD_DENSITY = {
  COMPACT: "compact",
  COMFORT: "comfort",
};

export const CARD_LAYOUT = {
  CARDS_TOP: "top",
  CARDS_RIGHT: "right",
};

export const CLINICAL_SIGNIFICANCE_COLORS_STRINGS = {
  benign: "Benign",
  "likely benign": "Benign",
  "uncertain significance": "UncertainSignificance",
  "conflicting interpretations of pathogenicity": "UncertainSignificance",
  "likely pathogenic": "LikelyPathogenic",
  pathogenic: "Pathogenic",
  disease: "Pathogenic",
  polymorphism: "Benign",
};

export const ANALYTICS_CATEGORIES = {
  NOTIFICATIONS: "Notifications",
  CARDS_UI: "Cards UI",
  CLINVAR: "ClinVar Submission",
  ANALYSIS_PAGE_HEADER_BUTTONS: "Analysis Page - Header buttons",
  PUBLICATIONS: "Publications",
};
